export const findRefs = (
	params: URLSearchParams
): { [key: string]: string } => {
	const refs: { [key: string]: string } = {};

	params.forEach((value, key) => {
		if (key.startsWith('ref:')) {
			const refKey = key.split('ref:')[1];
			refs[refKey] = value;
		}
	});

	return refs;
};

// TODO - Don't think we need a custom function here when we could just use URLSearchParams which is more predictable
// Only wrinkle is minor differences in encoding (spaces as '+' vs '%20') etc and what that could effect downstream
export const refsToUrlParams = (refs: { [key: string]: string }): string => {
	if (!refs) {
		return '';
	}

	let urlParams = '';

	Object?.keys(refs)?.forEach((key) => {
		const value = refs[key];
		urlParams += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
	});

	return urlParams;
};
